
// api/index.js

import axios from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
const API_URL = process.env.API_URL

axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.data && error.response.data.location) {
    window.location.href = error.response.data.location
  } else {
    return Promise.reject(error)
  }
})

export function bindRedeem (code) {
  return axios.get(`${API_URL}/bind_redeem?code=${code}`)
}

export function wxOAuth () {
  return axios.get(`${API_URL}/wx_oauth`)
}

export function queryUser (openid) {
  return {exist: true}
}

export function postLevelData (data, params) {
  const url = `${API_URL}/uploader`
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function postLevelData2 (formData) {
  const url = `${API_URL}/view_level_data`
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function postJsonData (resName, data) {
  const url = `${API_URL}/${resName}`
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const DOWNLOAD_API = `${API_URL}/download/`

export function postData2Backend (data) {
  // 'null' 不可省略, 否则返回 404. 'null' 可改为任意其他字符, post 方法会无视其值
  const url = DOWNLOAD_API + 'null'
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default DOWNLOAD_API



// WEBPACK FOOTER //
// ./src/api/index.js